import { NameAvatar } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';

import { getName } from '@hero/utils';

import * as S from './style';

function TableName({ firstName, lastName, isShownAvatar = true, onClick }) {
  const TableNameWrapper = onClick ? S.TableNameButton : S.TableNameText;

  return (
    <TableNameWrapper
      {...(!onClick && { as: 'div' })}
      variant="link"
      onClick={onClick}
      color="neutral"
    >
      {isShownAvatar && <NameAvatar name={`${firstName} ${lastName}`} />}
      <S.Name>{getName({ firstName, lastName })}</S.Name>
    </TableNameWrapper>
  );
}

TableName.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  isShownAvatar: PropTypes.bool,
  onClick: PropTypes.func
};

export { TableName };
